const UsersStrings = {
    status: {
        true: "Отключен",
        false: "Активный"
    }
}

export default UsersStrings;